import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormInput,
  FormTemplate,
  FormTextArea,
  FormSelect,
  FormSelectAlt,
  FormInputAlt,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useDispatch, useSelector } from "react-redux";
import { FiPlus } from "react-icons/fi";
import {
  GetCategories,
} from "../../../../../utils/redux/AssetsSetUp/AssetSetUpSlice";
import { BsDash } from "react-icons/bs";
import { useNavigate } from "react-router";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import style from "./styleJS";
import { CreateCostService, GetCostClasses, GetGlobalData, UpdateCostService } from "../../../../../utils/redux/Finance/CostCenterSlice/CostCenterSlice";
import OptionDropDown from "../../../Components/Misc/OptionDropDown";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import { toast } from "react-toastify";

function CostCenterServiceSetup() {
  const { isLoading, CostCenterClass, editMode, CostCenterService:editData } = useSelector(state=> state.costCenter);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log({editData})
  

  const defaultData = {};
  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods;

  const {
    Employees=[],
    Departments=[],
    Branches=[],
    Cadres=[],
    Banks=[],
  } = useSelector(state=> state.costCenter.GlobalData);
  console.log({ Branches })
  
  useEffect(()=>{
    dispatch(GetGlobalData({subGroup: "general"}));
    dispatch(GetCostClasses())
  },[]);

  const [structure ,setStructure] = useState(editMode?editData.organizationStructure : null);
  const [searchEmployee, setSearchEmployee] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(editMode? editData.employee : {});
  const [selectedBank, setSelectedBank] = useState(editMode? editData.chartOfAccountSetupid : {});

  // Search results options for employee name typed in the employeeName section
  const [optionOpen, setOptionOpen] = useState(false);

  // Submit function to create or update the costService
  const submit = (data) => {
    if(structure === 1 && !selectedEmployee?.accountName){
      toast.error('Please select an employee!')
    }

    if(editMode) {
      data.id = editData.id;
      data.groupID = 1;
    }

    // Formatting all data fields
    let currentStructureKey = structure === 1? "employeeID": structure === 2? "employeeCadrePositionId": structure === 3? "departmentID": structure === 4? "branchID" : null;
    const fmtData = {
      limit: parseInt(data.limit),
      duration: parseInt(data.duration),
      costClassID: parseInt(data.costClassID),
      organizationStructure: structure,
      chartOfAccountSetupid: parseInt(selectedBank),
      [currentStructureKey]: structure === 1? selectedEmployee?.id : structure === 2? parseInt(data.cadreID) : structure === 3? parseInt(data.departmentID) : structure === 4? parseInt(data.branchID) : null,
      // branchID: structure === 4? parseInt(data.branchID) : 0,
      // employeeID: structure === 1? selectedEmployee?.id : 0,
      // departmentID: structure === 3? parseInt(data.departmentID) : 0,
      // employeeCadrePositionId: structure === 2? parseInt(data.cadreID) : 0,
    }


    console.log({submitData: fmtData})
    if(editMode){
      dispatch(UpdateCostService({...fmtData, id: editData?.id}))
      .then((response)=> {
        response.meta.requestStatus === "fulfilled" && navigate("../"); 
        console.log({ServiceUpdateRes: response})
      })
    } else {
      dispatch(CreateCostService(fmtData))
      .then(response=> {
        response.meta.requestStatus === "fulfilled" && navigate("../"); 
      })
    }
  };

  const structures = [{name: "Employee", val: 1}, {name: "Cadre", val: 2}, {name: "Department", val: 3},{name: "Branch", val: 4}];

  // console.log({searchEmployee})
  
  return (
    <RouteLayout title={"Finance"}>
      <PageLayout title={"Setup Cost Center Service"} hasBack={true}>
        <FormProvider {...formMethods}>
          <FormTemplate
            className={DashboardStyle.view_app_components}
            handleSubmit={handleSubmit(submit)}
          >
            <section className={DashboardStyle.form_section}>
              <h4 className={style.setup.sectionHeader}>Organizational <br/> Structure</h4>
              <div className={DashboardStyle.inputs_group}>
                <div>
                  <FormSelectAlt
                    title={"Organizational Structure"}
                    camelCase={"organizationStructure"}
                    placeholder={"Select Structure"}
                    isOptional={false}
                    defaultValue={structures.find(s=> s.val === structure)?.name}
                    array={structures.map((item, i)=> <option selected={(editMode && item.name.toLowerCase()===editData.subgroupID)} key={i} value={item.val}>{item.name}</option>)}
                    moreRegister={{
                      onChange: (e) => { // what to do when selection changes
                        let item = parseInt(e.target.value);
                        setStructure(item)
                        return null;
                      },
                    }}
                  />
                </div>
              </div>
            </section>
            <section className={DashboardStyle.form_section}>
              <h4 className={style.setup.sectionHeader}>Basic <br/>Information</h4>
              <div className={DashboardStyle.inputs_group}>
                <div>
                  {structure === 1 && 
                  <div>
                    <FormInputAlt
                      title={"Employee"}
                      camelCase={"employeeID"}
                      placeholder={"Search for Employee..."}
                      isOptional={true}
                      defaultValue={""}
                      // value={selectedEmployee?.accountName}
                      array={[]}
                      onBlur={()=> setOptionOpen(false)}
                      onChange={(e) => { // what to do when selection changes
                        let val = e.target.value?.trim();
                        setSearchEmployee(val);
                      }}
                      moreRegister={{
                        onChange: (e) => { // what to do when selection changes
                          
                          // console.log(e.target.value);
                        },
                      }}
                    />
                    {selectedEmployee?.accountName?.length>0 && <p>Selected Employee: <span className="text-xl font-bold text-green-700">{selectedEmployee?.accountName}</span></p>}
                    
                    {searchEmployee?.length>0 &&
                    <ActionButtons 
                      type="button" 
                      onClick={()=> {
                        setOptionOpen(true);
                        console.log({selectedEmployee})
                        dispatch(GetGlobalData({val: searchEmployee, subGroup: "employees"}));
                      }}
                    >
                      Search
                    </ActionButtons>}
                    {optionOpen &&
                      <OptionDropDown closeDropDown={()=> setOptionOpen(false)} data={Employees} 
                        onChoose={(item)=>{ setSelectedEmployee(item); setOptionOpen(false)}} 
                      />
                    }
                  </div>}
                  {(structure === 2) && 
                  <FormSelectAlt
                    title={"Cadre"}
                    camelCase={"cadreID"}
                    placeholder={"Select Cadre"}
                    isOptional={false}
                    array={Cadres?.map((item, i)=> <option selected={editMode && editData?.cadre === item.id} key={i} value={item.id}>{`${item?.title}`}</option>)}
                    moreRegister={{
                      onChange: (e) => { // what to do when selection changes
                        // dispatch(
                        //   GetAssetClass({
                        //     pageSize: 100000,
                        //     currentPage: 1,
                        //     sort: 0,
                        //     filter: 0,
                        //     CategoryId: e.target.value,
                        //   })
                        // );
                        return null;
                      },
                    }}
                  />}
                  {(structure === 3) && 
                  <FormSelectAlt
                    title={"Department"}
                    camelCase={"departmentID"}
                    placeholder={"Select Department"}
                    isOptional={false}
                    defaultValue={editMode? Departments.find(D=> D.id == editData?.deptID) : null}
                    array={Departments.filter(item=> { 
                      // console.log({item})
                      if(selectedEmployee && structure === 1){
                        return selectedEmployee.departmentId === item.id
                      }
                      return item
                    }).map((item, i)=> <option selected={editMode && editData?.department?.id === item.id} key={i} value={item.id}>{item.description}</option>)}
                    moreRegister={{
                      onChange: (e) => { // what to do when selection changes
                        // dispatch(
                        //   GetAssetClass({
                        //     pageSize: 100000,
                        //     currentPage: 1,
                        //     sort: 0,
                        //     filter: 0,
                        //     CategoryId: e.target.value,
                        //   })
                        // );
                        return null;
                      },
                    }}
                  />}
                  { (structure === 4) && 
                    <FormSelectAlt
                      title={"Branch"}
                      camelCase={"branchID"}
                      placeholder={"Select a Branch"}
                      isOptional={false}
                      array={Branches?.map((item, i)=> <option key={i} value={item.id}>{item.name}</option>)}
                      moreRegister={{
                        onChange: (e) => { // what to do when selection changes
                          // dispatch(
                          //   GetAssetClass({
                          //     pageSize: 100000,
                          //     currentPage: 1,
                          //     sort: 0,
                          //     filter: 0,
                          //     CategoryId: e.target.value,
                          //   })
                          // );
                          return null;
                        },
                      }}
                    />
                  }

                  <div>
                    <FormSelectAlt
                      title={"Chart of Account"}
                      camelCase={"ChartOfAccount"}
                      placeholder={"Select Account"}
                      isOptional={false}
                      defaultValue={editMode? editData?.chartofAccountSetup?.groupName : null}
                      array={Banks?.map((item, i)=> <option key={i} value={item.id}>{item.groupName}</option>)}
                      moreRegister={{
                        onChange: (e) => { // what to do when selection changes
                          let { value } = e.target;
                          setSelectedBank(value);
                          return null;
                        },
                      }}
                    />
                  </div>
                </div>
                
                <div>
                  <FormInputAlt
                    title={"Budgeted Amount"}
                    camelCase={"limit"}
                    placeholder={"Enter Budgeted Amount"}
                    isOptional={false}
                    defaultValue={editMode? editData?.limit: null}
                    array={[]}
                    type={'number'}
                    onChange={(e)=>{
                      // let val = e.target.value;
                      // let money = FormatCurrency(val);
                      // setMinimumAmount(money)
                    }}
                    moreRegister={{
                      onChange: (e) => { // what to do when selection changes
                        // dispatch(
                        //   GetAssetClass({
                        //     pageSize: 100000,
                        //     currentPage: 1,
                        //     sort: 0,
                        //     filter: 0,
                        //     CategoryId: e.target.value,
                        //   })
                        // );
                        return null;
                      },
                    }}
                  />

                  <FormSelectAlt
                    title={"Class"}
                    camelCase={"costClassID"}
                    placeholder={"Select Class"}
                    isOptional={false}
                    array={(CostCenterClass.pageItems || []).map((item, i)=> <option selected={editMode && editData?.costClassID === item.id} key={i} value={item.id}>{item.name}</option>)}
                    moreRegister={{
                      onChange: (e) => { // what to do when selection changes
                        // dispatch(
                        //   GetAssetClass({
                        //     pageSize: 100000,
                        //     currentPage: 1,
                        //     sort: 0,
                        //     filter: 0,
                        //     CategoryId: e.target.value,
                        //   })
                        // );
                        return null;
                      },
                    }}
                  />
                </div>

                <div>
                  <FormSelectAlt
                    title={"Duration"}
                    camelCase={"duration"}
                    placeholder={"Select Duration"}
                    isOptional={false}
                    type="number"
                    array={[{val: 1, name: 'Monthly'}, {val: 2, name: 'Quaterly'}, {val:3, name:'Annually'}].map((item, i)=> <option selected={editMode && editData?.duration === item.val} key={i} value={item.val}>{item.name}</option>)}
                    
                  />
                </div>
              </div>
            </section>

            <div className={DashboardStyle.button_cage}>
              <SupportButtons
                onClick={() => { reset(); navigate(-1); }}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Cancel
              </SupportButtons>
              <ActionButtons
                isLoading={isLoading}
                disabled={!isValid}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Submit
              </ActionButtons>
            </div>
          </FormTemplate>
        </FormProvider>
      </PageLayout>
    </RouteLayout>
  );
}

// function RegisterLineItem({ fieldName, asset_class, index, remove, append }) {
//   const [isFoundData, setIsFouncData] = useState();
//   return (
//     <>
//       <div style={{ gridTemplateColumns: "1fr" }}>
//         <FormSelect
//           title={"Class"}
//           camelCase={`${fieldName}.classId`}
//           placeholder={"select"}
//           array={asset_class?.responseObject?.map?.((x, index) => (
//             <option key={index} value={+x?.id}>
//               {x?.name}
//             </option>
//           ))}
//           moreRegister={{
//             onChange: (e) => {
//               const isFound = asset_class?.responseObject?.find(
//                 (x) => +e.target.value === +x?.id
//               );

//               // dispatch(
//               //   GetAssetSubClass({
//               //     pageSize: 100000,
//               //     currentPage: 1,
//               //     sort: 0,
//               //     filter: 0,
//               //     CategoryId: isFound?.categoryId,
//               //     AssetClassId: e.target.value,
//               //   })
//               // );

//               // console.log({ isFound });

//               return setIsFouncData(isFound);
//             },
//             // return console.log({ data });
//           }}
//         />
//       </div>
//       <div>
//         <FormSelect
//           title={"Sub Class"}
//           camelCase={`${fieldName}.classSubClassId`}
//           placeholder={"select"}
//           array={isFoundData?.subClasses?.map?.((x, index) => (
//             <option key={index} value={+x?.id}>
//               {x?.name}
//             </option>
//           ))}
//         />

//         <FormInput
//           title={"Asset Name"}
//           camelCase={`${fieldName}.assetName`}
//           placeholder={"select"}
//           type="text"
//         />
//       </div>
//       <div>
//         <FormTextArea
//           title={"Asset Description"}
//           camelCase={`${fieldName}.assetDescription`}
//           placeholder={"select"}
//           type="textbox"
//           rowsLines={4}
//         />
//         <FormInput
//           title={"Asset Brand"}
//           camelCase={`${fieldName}.assetBrand`}
//           placeholder={"select"}
//           type="text"
//         />
//       </div>
//       {index !== 0 ? (
//         <div
//           style={{
//             color: "#E61B00",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             gap: "5px",
//             marginTop: "1rem",
//           }}
//           onClick={() => remove?.(index)}
//         >
//           <BsDash />

//           <p>Remove Setup</p>
//         </div>
//       ) : (
//         <div
//           style={{
//             color: "var(--primary-color)",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             gap: "5px",
//             marginTop: "1rem",
//           }}
//           onClick={() => append?.({})}
//         >
//           <FiPlus />
//           <p>Add Another</p>
//         </div>
//       )}
//     </>
//   );
// }

export default CostCenterServiceSetup;


